import { render, staticRenderFns } from "./autoCard.vue?vue&type=template&id=3d74a6e2&scoped=true&"
import script from "./autoCard.vue?vue&type=script&lang=js&"
export * from "./autoCard.vue?vue&type=script&lang=js&"
import style0 from "./autoCard.vue?vue&type=style&index=0&id=3d74a6e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d74a6e2",
  null
  
)

export default component.exports